import React from 'react';
import { LinkWrapper } from '../../utils/link';
import { render, MARK_LINK } from 'storyblok-rich-text-react-renderer';

const SubmissionModal = ({ message }) => {
  const RichText = ({ document }) => {
    return render(document, {
      markResolvers: {
        [MARK_LINK]: (children, props) => {
          return <LinkWrapper link={props}>{children}</LinkWrapper>;
        },
      },
    });
  };

  return <div className="px-4 md:px-8">{RichText({ document: message })}</div>;
};

export default SubmissionModal;
